export default __webpack_public_path__ + "static/media/airbnb_social.2b9157aa.svg";